import formatDateInLocalTimezone from '@insided/shared/utils/dateFormatting'

export interface LocalDatetimeProps {
  timestamp: string
  showTime?: boolean
}

const LocalDatetime = (props: LocalDatetimeProps) => {
  const { timestamp, showTime = true } = props

  if (!parseInt(timestamp)) {
    return ''
  }

  return formatDateInLocalTimezone(timestamp, showTime)
}

export default LocalDatetime
